// @ts-nocheck
import React, {FC, useMemo} from 'react';
import {MaterialReactTable, MRT_ColumnDef as MRTColumnDef} from 'material-react-table';
import Moment from 'react-moment';
import ModalConfirmOvertake from '../../Modals/modal-confirmovertake';
import {Typography} from '@mui/material';

interface OvertakeListProps {
  isLoading?: boolean;
  overtakes: Overtake[];
}

export const OvertakeList: FC<OvertakeListProps> = ({
  isLoading,
  overtakes,
}) => {
  const columns = useMemo<MRTColumnDef<Overtake>[]>(() => [
    {
      header: 'Date + Time',
      accessorKey: 'created_at',
      Cell: ({cell}) => (
        <Moment format="DD-MM-YYYY">{cell.getValue()}</Moment>
      ),
    },
    {
      header: 'Printer Serial',
      accessorKey: 'printer_serial_no',
    },
    {
      header: 'Engineer',
      accessorFn: (row) =>
        row.new_engineer ?
          `${row.new_engineer.firstname} ${row.new_engineer.lastname}` :
          '',
    },
    {
      header: 'Dealer',
      accessorKey: 'current_dealer.name',
      accessorFn: (row) => row.current_dealer?.name ?? '',
    },
    {
      header: 'New Customer',
      accessorFn: (row) => row.new_customer?.name ?? '',
    },
    {
      header: 'Old Customer',
      accessorFn: (row) => row.current_customer?.name ?? '',
    },
    {
      header: 'Actions',
      accessorKey: 'id',
      Cell: ({row}) =>
        row.original.confirmed === 0 ? (
          <ModalConfirmOvertake overtake={row.original} />
        ) : (
          ''
        ),
    },
  ], []);

  return (
    <MaterialReactTable
      columns={columns}
      data={overtakes}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      renderTopToolbarCustomActions={() => (
        <Typography variant="h6">Overtakes</Typography>
      )}
    />
  );
};
